import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="foter">
      <div className="contact-footer">
        <div>
          <h5>Teléfono</h5>
          <p>+52 55 3644 5094</p>
        </div>
        <div>
          <h5>Dirección</h5>
          <p>Las Américas, Ecatepec, Estado de México</p>
        </div>
        <div>
          <h5>Correo</h5>
          <p>informacion@zurainmobiliaria.property</p>
        </div>
      </div>

      {/* <div className="fondo-footer">
        <div className="form-fondo">
          <div className="form-text">
            <h6>SUSCRÍBASE A NUESTRA LISTA DE CORREO</h6>
            <p>Regístrese para recibir la información más reciente</p>
          </div>
          <form action="">
            <fieldset className="formFoter">
              <input type="text" placeholder="Ingrese su email" />
              <button type="submit">Enviar</button>
            </fieldset>
          </form>
        </div>
      </div> */}
      <div className="fono-footer" >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15028.445362!2d-99.0447!3d19.6089!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1f48b6e5d8b8f%3A0x8b8b8b8b8b8b8b8b!2sLas%20Am%C3%A9ricas%2C%20Ecatepec%20de%20Morelos%2C%20M%C3%A9x.!5e0!3m2!1ses-419!2smx!4v1638000000000!5m2!1ses-419!2smx"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Ubicación Las Américas, Ecatepec">
        </iframe>
      </div>

      <div className="Copyright">
        <p>Copyright © 2024 Zura Inmobiliaria. Todos los derechos reservados.
          </p>
        <div className="redes-sociales">
          <a href="/" role="button" aria-label="Facebook">
            <i className="fa fa-facebook"></i>
          </a>
          <a href="/" role="button" aria-label="Instagram">
            <i className="fa fa-instagram"></i>
          </a>
          <a href="/" role="button" aria-label="LinkedIn">
            <i className="fa fa-linkedin"></i>
          </a>
          <a href="/" role="button" aria-label="Twitter">
            <i className="fa fa-twitter"></i>
          </a>
          <a href="/" role="button" aria-label="YouTube">
            {" "}
            <i className="fa fa-whatsapp"></i>
          </a>
        </div>
      </div>
    </div>
  );
}
